import type React from 'react';

const AlcuSvgIcon: React.FC<React.SVGAttributes<SVGElement>> = () => {
  return (
    <svg width="193" height="69" viewBox="0 0 193 69" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8265 67.814H0L13.7441 1.09599H42.593L51.9825 46.7163V45.4833V23.4267C51.9825 8.21988 59.3309 0 75.5244 0H78.5181C92.6705 0 99.7466 6.57591 100.971 17.6727V1.09599H119.886V49.5933H142.204V1.09599H160.983V45.8943C160.983 49.5933 162.207 51.6483 166.426 51.6483H168.739C172.822 51.6483 174.182 49.7303 174.182 45.8943V1.23298H192.961V45.0724C192.961 60.6901 184.797 68.91 168.875 68.91H166.29C155.131 68.91 147.783 65.0741 144.109 56.8542V67.814H100.971V50.5523C99.7466 62.1971 91.9901 68.91 77.5656 68.91H75.5244C64.638 68.91 57.5618 65.0741 54.2959 57.6762L56.3371 67.814H37.8302L35.653 56.1692H20.0038L17.8265 67.814ZM22.8615 41.3729L27.3522 16.5762H28.3047L32.9315 41.3729H22.8615ZM76.4768 51.648C72.2584 51.648 70.7615 49.593 70.7615 45.6201V23.4264C70.7615 19.3164 72.2584 17.3985 76.4768 17.3985H78.518C82.7365 17.3985 84.2334 19.4534 84.2334 23.4264V28.0843H101.107V40.8251H84.2334V45.4831C84.2334 49.593 82.7365 51.511 78.518 51.511H76.4768V51.648Z"
      />
    </svg>
  );
};

export default AlcuSvgIcon;
